import { NavLink } from 'react-router-dom';
import {
  Boxes, Building2, FileSignature, FolderSearch, Link2, PenTool, ScrollText, Tags,
} from 'lucide-react';

/**
 * LEGAL SECTION TABS — one strip across the top of every /legal page.
 *
 * Eight sibling screens that were reachable only through the sidebar, so going
 * from a policy to the binding that requires it meant hunting the left rail
 * every time. Same order and icons as the sidebar (Layout.tsx) so the two never
 * disagree. Rendered in StaffPage's `tabs` slot: ruby pills on the black header,
 * the house pattern from StaffSubtabs.
 *
 * NavLink without `end`, so /legal/policies/:id and /legal/agreements/send keep
 * their parent tab lit.
 */
const LEGAL_TABS = [
  { to: '/legal/policies', label: 'Policies', icon: ScrollText },
  { to: '/legal/agreements', label: 'Agreements', icon: FileSignature },
  { to: '/legal/categories', label: 'Categories', icon: Tags },
  { to: '/legal/company', label: 'Company Profile', icon: Building2 },
  { to: '/legal/packs', label: 'Packs', icon: Boxes },
  { to: '/legal/bindings', label: 'Bindings', icon: Link2 },
  { to: '/legal/hub', label: 'Documents Hub', icon: FolderSearch },
  { to: '/legal/signatures', label: 'Signatures', icon: PenTool },
] as const;

export default function LegalNav() {
  return (
    <nav aria-label="Legal sections" className="-mx-1 flex items-center gap-1 overflow-x-auto px-1 scrollbar-hide">
      {LEGAL_TABS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => `flex min-h-[44px] shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg border px-3.5 text-xs font-semibold transition ${
            isActive
              ? 'border-[rgba(220,20,60,0.5)] bg-[rgba(220,20,60,0.16)] text-rose-300'
              : 'border-transparent text-gray-400 hover:bg-white/5 hover:text-white'
          }`}
        >
          <Icon size={14} />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
